import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID ,
  appId: process.env.REACT_APP_APP_ID 
  // appId: "1:892435779270:web:53f4aaa86b3344d2",
  // apiKey: "AIzaSyBehX-0_61woayouo2MAxXwdpkErqZkOno",
  // authDomain: "react-notes-56e35.firebaseapp.com",
  // databaseURL: "https://react-notes-56e35.firebaseio.com",
  // projectId: "react-notes-56e35",
  // storageBucket: "react-notes-56e35.appspot.com",
  // messagingSenderId: "892435779270"
}

// firebase.initializeApp({
//   apiKey: 'AIzaSyBehX-0_61woayouo2MAxXwdpkErqZkOno',
//   authDomain: 'react-notes-56e35.firebaseapp.com',
//   projectId: 'react-notes-56e35',
//   storageBucket: "react-notes-56e35.appspot.com",
//     messagingSenderId: "892435779270"
// });

// Initialize Cloud Firestore through Firebase
// const db = firebase.firestore();

// Disable deprecated features
// db.settings({
//   timestampsInSnapshots: true
// });




// if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
// }
// Init firestore
const firestore = firebase.firestore();

const getCurrentUser = () => {
  return firebase.auth().currentUser
}

export {firebase, firebaseConfig, firestore, getCurrentUser}


